var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfetti = function SvgConfetti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#confetti_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8BB6EF",
    d: "M30.949 72.69a4 4 0 0 1-1.733.982l-6.196 1.694c-2.34.64-4.819-.03-6.47-1.75l-3.24-3.375c-1.651-1.72-2.22-4.224-1.486-6.536l2.004-6.587-8.017 2.072a4.047 4.047 0 0 1-2.135-7.806l6.196-1.695c2.34-.64 4.819.031 6.47 1.75l3.24 3.376c1.651 1.72 2.22 4.224 1.486 6.535L18.75 68l8.33-2.134a4.047 4.047 0 0 1 3.869 6.826"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8388EF",
    d: "m13.828 57.118-.211.694-1.794 5.893a6.58 6.58 0 0 0 .855 5.767c1.831-.419 4.266-.949 6.07-1.474l.298-.852 2.021-5.796c.661-2.081.265-4.318-1.025-5.998-1.845.548-4.362 1.246-6.214 1.766"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A183E2",
    d: "M57.443 73.604c.606.243 1.28.344 1.974.263l6.38-.74c2.41-.28 4.46-1.828 5.35-4.04l1.746-4.34c.89-2.212.483-4.748-1.061-6.618l-4.319-5.363 8.212-1.07a4.047 4.047 0 1 0-.934-8.04l-6.38.741c-2.41.28-4.46 1.828-5.349 4.039l-1.746 4.34c-.89 2.212-.484 4.748 1.06 6.618l4.633 5.303-8.525 1.13a4.047 4.047 0 0 0-1.041 7.777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9762E2",
    d: "m67.513 52.766.454.565 3.864 4.797a6.58 6.58 0 0 1 1.359 5.67c-1.855.295-4.311.712-6.182.899l-.593-.68-4.04-4.623c-1.39-1.684-1.857-3.907-1.287-5.947 1.916-.18 4.511-.472 6.425-.681"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA585",
    d: "M39.411 54.072a4 4 0 0 0 1.535-1.27l3.79-5.185c1.432-1.959 1.689-4.514.67-6.67l-1.998-4.23c-1.019-2.155-3.156-3.58-5.578-3.717l-6.869-.474 4.793-6.753a4.047 4.047 0 0 0-6.533-4.776l-3.791 5.185c-1.431 1.958-1.688 4.513-.67 6.669l1.999 4.23c1.018 2.155 3.155 3.58 5.577 3.717l7.038.203-4.962 7.024a4.047 4.047 0 0 0 4.999 6.047"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF7C85",
    d: "m30.58 33.097.382-.572 6.869.475a6.58 6.58 0 0 1 5.083 2.854 92 92 0 0 1-2.912 4.076q-.375.499-.627 1.07l-7.038-.202c-2.18-.124-4.13-1.291-5.24-3.096a371 371 0 0 0 3.483-4.605"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE266",
    d: "m10.6 41.81-3.392-1.697a2.05 2.05 0 0 1-.917-2.749l1.697-3.393a2.05 2.05 0 0 1 2.75-.916l3.392 1.696a2.05 2.05 0 0 1 .917 2.75l-1.697 3.393a2.05 2.05 0 0 1-2.75.916"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF8BBD",
    d: "m39.028 72.332 3.648-1.042a2.05 2.05 0 0 1 2.533 1.408l1.042 3.648a2.05 2.05 0 0 1-1.407 2.533l-3.648 1.042a2.05 2.05 0 0 1-2.533-1.408l-1.042-3.647a2.05 2.05 0 0 1 1.407-2.534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78EAC4",
    d: "m65.043 34.267-4.79 2.765a2.987 2.987 0 0 1-4.081-1.093l-2.765-4.79a2.99 2.99 0 0 1 1.093-4.08l4.79-2.766a2.987 2.987 0 0 1 4.08 1.094l2.766 4.79a2.99 2.99 0 0 1-1.093 4.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAB4EF",
    d: "m14.19 7.715 1.32 3.712a.6.6 0 0 0 .31.348l3.297 1.486c.466.21.466.952 0 1.162l-3.297 1.486a.6.6 0 0 0-.31.348l-1.32 3.711c-.186.525-.846.525-1.032 0l-1.32-3.711a.6.6 0 0 0-.31-.349l-3.297-1.485c-.466-.21-.466-.952 0-1.162l3.297-1.486a.6.6 0 0 0 .31-.348l1.32-3.712c.186-.524.846-.524 1.032 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC7B6",
    d: "m63.466.292.979 2.753a.44.44 0 0 0 .23.258l2.445 1.102c.346.156.346.706 0 .862L64.674 6.37a.44.44 0 0 0-.23.259l-.978 2.753c-.139.388-.628.388-.766 0l-.98-2.753a.44.44 0 0 0-.229-.259l-2.446-1.102c-.345-.156-.345-.706 0-.862l2.446-1.102a.44.44 0 0 0 .23-.258L62.7.292c.138-.39.627-.39.766 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BB6EF",
    d: "M50.02 17.24a2.883 2.883 0 1 0-2.208-5.326 2.883 2.883 0 0 0 2.208 5.326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF8BBD",
    d: "M22.9 7.323a1.243 1.243 0 1 0 0-2.487 1.243 1.243 0 0 0 0 2.486"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE266",
    d: "M74.193 26.323a1.243 1.243 0 1 0 0-2.487 1.243 1.243 0 0 0 0 2.487"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "confetti_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z"
  })))));
};
export default SvgConfetti;